var render = function render(){var _vm=this,_c=_vm._self._c;return _c('widget-settings-flat-item',{attrs:{"title":_vm.title},scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c('v-switch',{staticClass:"ma-0 pa-0",attrs:{"input-value":_vm.value,"color":"primary","hide-details":""},on:{"change":function($event){return _vm.$emit('input', $event)}}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }